module.exports = __webpack_public_path__ + "static/1248697352.bd1d1303.jpg";